/**
 * Link to the iOS app.
 */
export const iOS =
  'https://apps.apple.com/us/app/taxfyle-taxes-done-for-you/id1058033104'

/**
 * Link to the Android app.
 */
export const Android =
  'https://play.google.com/store/apps/details?gl=us&id=com.taxfyle.TaxfyleMobile'
